/* Pro Main Product desktop gallery — 50/50 click navigation with slide-to-slide transform motion */
(function () {
  var RUNTIME_KEY = 'PawlishMainGalleryClickNavRuntime';
  var VERSION = 'transform-slide-v4-arrow-lock';
  var existingRuntime = window[RUNTIME_KEY];

  if (existingRuntime && existingRuntime.version === VERSION && typeof existingRuntime.init === 'function') {
    existingRuntime.init(document);
    return;
  }

  if (existingRuntime && typeof existingRuntime.destroy === 'function') {
    existingRuntime.destroy(document);
  }

  var instances = new WeakMap();
  var desktopPointerQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var transitionDuration = 420;

  function getRoots(scope) {
    var roots = [];
    var root = scope && scope.querySelectorAll ? scope : document;

    if (root.matches && root.matches('.pro-main-product-root')) roots.push(root);
    root.querySelectorAll('.pro-main-product-root').forEach(function (productRoot) {
      roots.push(productRoot);
    });

    return roots;
  }

  function getSlides(mediaList) {
    return Array.from(mediaList.querySelectorAll(':scope > .product__media-item[data-media-id]'));
  }

  function getActiveIndex(slides) {
    var activeIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });

    return activeIndex >= 0 ? activeIndex : 0;
  }

  function slideSupportsClickNavigation(slide) {
    if (!slide) return false;

    var imageOpener = slide.querySelector('.product__modal-opener--image');
    var zoomToggle = slide.querySelector('.product__media-toggle.product__media-zoom-none');

    return Boolean(imageOpener && zoomToggle);
  }

  function getPreviewImage(slide) {
    if (!slide) return null;
    return slide.querySelector(
      '.product__modal-opener img, .deferred-media__poster img, .product__media img'
    );
  }

  function warmSlide(slide) {
    var image = getPreviewImage(slide);
    if (!image) return;

    image.loading = 'eager';
    if (typeof image.decode === 'function') {
      image.decode().catch(function () {});
    }
  }

  function waitForSlidePreview(slide, timeout) {
    var image = getPreviewImage(slide);
    if (!image) return Promise.resolve();

    image.loading = 'eager';

    if (image.complete && image.naturalWidth > 0) {
      if (typeof image.decode !== 'function') return Promise.resolve();
      return image.decode().catch(function () {});
    }

    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(done, timeout);

      function done() {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        image.removeEventListener('load', done);
        image.removeEventListener('error', done);
        resolve();
      }

      image.addEventListener('load', done, { once: true });
      image.addEventListener('error', done, { once: true });
    });
  }

  function pointInsideRect(event, rect) {
    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  }

  function initRoot(productRoot) {
    if (!productRoot || instances.has(productRoot)) return;

    var gallery = productRoot.querySelector('media-gallery');
    if (!gallery) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var mediaList = gallery.querySelector('[data-pro-main-gallery-list]');
    if (!viewer || !mediaList) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var cursor = document.createElement('span');
    var cursorFrame = null;
    var lastPointerEvent = null;
    var animating = false;
    var transitionToken = 0;
    var transitionTimer = null;
    var transitionTarget = null;
    var lockedCursorDirection = 0;
    var variantUnsubscribe = null;

    cursor.className = 'pro-main-gallery-click-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<path class="pro-main-gallery-click-cursor__shaft" d="M4.25 12h14.5" />' +
      '<path class="pro-main-gallery-click-cursor__head" d="m14.25 7.5 4.5 4.5-4.5 4.5" />' +
      '</svg>';
    viewer.appendChild(cursor);

    function slides() {
      return getSlides(mediaList);
    }

    function warmNeighbors(index) {
      var allSlides = slides();
      warmSlide(allSlides[index - 1]);
      warmSlide(allSlides[index + 1]);
    }

    function totalMedia() {
      return slides().length;
    }

    function getNavigationState(event) {
      var desktopLayout = gallery.dataset.desktopLayout || '';
      var supportedLayout = desktopLayout === 'thumbnail' || desktopLayout === 'thumbnail_slider';

      if (!desktopPointerQuery.matches || !supportedLayout || totalMedia() <= 1 || animating) return null;

      var allSlides = slides();
      var activeIndex = getActiveIndex(allSlides);
      var activeSlide = allSlides[activeIndex];
      if (!slideSupportsClickNavigation(activeSlide)) return null;

      var slideRect = activeSlide.getBoundingClientRect();
      if (!pointInsideRect(event, slideRect)) return null;

      var midpoint = slideRect.left + slideRect.width / 2;
      var direction = event.clientX < midpoint ? -1 : 1;
      var targetIndex = activeIndex + direction;

      if (targetIndex < 0 || targetIndex >= allSlides.length) return null;

      return {
        direction: direction,
        activeIndex: activeIndex,
        targetIndex: targetIndex,
        activeSlide: activeSlide,
        targetSlide: allSlides[targetIndex],
        slideRect: slideRect,
      };
    }

    function hideCursor() {
      viewer.classList.remove('pro-main-gallery-click-nav--active');
      cursor.classList.remove('is-visible', 'is-prev', 'is-next');
    }

    function renderCursor() {
      cursorFrame = null;
      if (!lastPointerEvent) return;

      var viewerRect = viewer.getBoundingClientRect();
      var cursorInset = 24;
      var direction = 0;
      var bounds = null;

      // During a slide transition, keep the exact arrow direction that initiated
      // the navigation. The pointer may continue to move, but the visual arrow
      // must not disappear, rotate, or expose the native cursor mid-transition.
      if (animating && lockedCursorDirection) {
        direction = lockedCursorDirection;
        bounds = viewerRect;
      } else {
        var state = getNavigationState(lastPointerEvent);
        if (!state) {
          hideCursor();
          return;
        }

        direction = state.direction;
        bounds = state.slideRect;
      }

      var clampedClientX = Math.min(
        Math.max(lastPointerEvent.clientX, bounds.left + cursorInset),
        bounds.right - cursorInset
      );
      var clampedClientY = Math.min(
        Math.max(lastPointerEvent.clientY, bounds.top + cursorInset),
        bounds.bottom - cursorInset
      );
      var x = clampedClientX - viewerRect.left;
      var y = clampedClientY - viewerRect.top;

      viewer.classList.add('pro-main-gallery-click-nav--active');
      cursor.classList.toggle('is-prev', direction < 0);
      cursor.classList.toggle('is-next', direction > 0);
      cursor.classList.add('is-visible');
      cursor.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%,-50%)';
    }

    function scheduleCursorRender(event) {
      lastPointerEvent = event;
      if (cursorFrame !== null) return;
      cursorFrame = window.requestAnimationFrame(renderCursor);
    }

    function clearTransitionClasses() {
      var allSlides = slides();

      mediaList.classList.remove(
        'pro-main-gallery-transitioning',
        'pro-main-gallery-transition--next',
        'pro-main-gallery-transition--prev',
        'is-running'
      );

      allSlides.forEach(function (slide) {
        slide.classList.remove('pro-main-gallery-slide--from', 'pro-main-gallery-slide--to');
      });
    }

    function cancelTransition() {
      transitionToken += 1;
      animating = false;
      transitionTarget = null;
      lockedCursorDirection = 0;

      if (transitionTimer !== null) {
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
      }

      clearTransitionClasses();
    }

    function commitNativeState(targetSlide) {
      if (!targetSlide) return;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(targetSlide.dataset.mediaId, false);
      } else {
        slides().forEach(function (slide) {
          slide.classList.toggle('is-active', slide === targetSlide);
        });
      }
    }

    function finishTransition(token, targetSlide) {
      if (!animating || token !== transitionToken || targetSlide !== transitionTarget) return;

      if (transitionTimer !== null) {
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
      }

      commitNativeState(targetSlide);

      window.requestAnimationFrame(function () {
        if (token !== transitionToken) return;

        clearTransitionClasses();
        animating = false;
        transitionTarget = null;
        lockedCursorDirection = 0;

        var activeIndex = getActiveIndex(slides());
        warmNeighbors(activeIndex);

        if (lastPointerEvent) {
          window.requestAnimationFrame(renderCursor);
        }
      });
    }

    function animateTo(state) {
      if (!state || animating) return;

      var targetSlide = state.targetSlide;
      var activeSlide = state.activeSlide;
      if (!targetSlide || !activeSlide) return;

      if (reducedMotionQuery.matches) {
        commitNativeState(targetSlide);
        warmNeighbors(state.targetIndex);
        return;
      }

      animating = true;
      transitionTarget = targetSlide;
      lockedCursorDirection = state.direction;

      // Keep the premium cursor visible and direction-locked while the two
      // media frames slide. Do not reveal the native cursor during the click.
      viewer.classList.add('pro-main-gallery-click-nav--active');
      cursor.classList.toggle('is-prev', lockedCursorDirection < 0);
      cursor.classList.toggle('is-next', lockedCursorDirection > 0);
      cursor.classList.add('is-visible');

      var token = ++transitionToken;
      warmSlide(targetSlide);

      waitForSlidePreview(targetSlide, 700).then(function () {
        if (!animating || token !== transitionToken || targetSlide !== transitionTarget) return;

        clearTransitionClasses();
        mediaList.classList.add('pro-main-gallery-transitioning');
        mediaList.classList.add(
          state.direction > 0 ? 'pro-main-gallery-transition--next' : 'pro-main-gallery-transition--prev'
        );
        activeSlide.classList.add('pro-main-gallery-slide--from');
        targetSlide.classList.add('pro-main-gallery-slide--to');

        // Force the initial +/-100% transform to paint before starting the transition.
        void targetSlide.offsetWidth;

        var onTransitionEnd = function (event) {
          if (event.target !== targetSlide || event.propertyName !== 'transform') return;
          targetSlide.removeEventListener('transitionend', onTransitionEnd);
          finishTransition(token, targetSlide);
        };

        targetSlide.addEventListener('transitionend', onTransitionEnd);

        transitionTimer = window.setTimeout(function () {
          targetSlide.removeEventListener('transitionend', onTransitionEnd);
          finishTransition(token, targetSlide);
        }, transitionDuration + 140);

        window.requestAnimationFrame(function () {
          if (!animating || token !== transitionToken) return;
          mediaList.classList.add('is-running');
        });
      });
    }

    viewer.addEventListener(
      'pointermove',
      function (event) {
        if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') {
          hideCursor();
          return;
        }
        scheduleCursorRender(event);
      },
      { signal: signal, passive: true }
    );

    viewer.addEventListener(
      'pointerleave',
      function () {
        lastPointerEvent = null;
        hideCursor();
      },
      { signal: signal, passive: true }
    );

    viewer.addEventListener(
      'click',
      function (event) {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          event.target.closest('.skip-to-content-link, .slider-buttons')
        ) {
          return;
        }

        var state = getNavigationState(event);
        if (!state) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        animateTo(state);
      },
      { capture: true, signal: signal }
    );

    gallery.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest('[id^="GalleryThumbnails"] [data-target]')) return;
        cancelTransition();
        window.requestAnimationFrame(function () {
          warmNeighbors(getActiveIndex(slides()));
        });
      },
      { capture: true, signal: signal }
    );

    function handleCapabilityChange() {
      cancelTransition();
      lastPointerEvent = null;
      hideCursor();
    }

    desktopPointerQuery.addEventListener('change', handleCapabilityChange, { signal: signal });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== productRoot.dataset.section) return;
        cancelTransition();
        window.requestAnimationFrame(function () {
          warmNeighbors(getActiveIndex(slides()));
        });
      });
    }

    window.requestAnimationFrame(function () {
      warmNeighbors(getActiveIndex(slides()));
    });

    instances.set(productRoot, {
      destroy: function () {
        cancelTransition();
        controller.abort();
        if (typeof variantUnsubscribe === 'function') variantUnsubscribe();
        if (cursorFrame !== null) window.cancelAnimationFrame(cursorFrame);
        cursor.remove();
        viewer.classList.remove('pro-main-gallery-click-nav--active');
      },
    });
  }

  function init(scope) {
    getRoots(scope).forEach(initRoot);
  }

  function destroy(scope) {
    getRoots(scope).forEach(function (productRoot) {
      var instance = instances.get(productRoot);
      if (!instance) return;
      instance.destroy();
      instances.delete(productRoot);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  window[RUNTIME_KEY] = { version: VERSION, init: init, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
